import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useMounted } from '@/shared/hooks/use-mounted';
import { ImageShape } from '@/shared/lib/types';
import Image from '../Image';

const LogoSlider = ({ images }: { images: ImageShape[] }) => {
    const isMounted = useMounted();

    return (
        <>
            {isMounted && (
                <Swiper
                    modules={[Autoplay]}
                    speed={1000}
                    spaceBetween={10}
                    slidesPerView={1}
                    autoplay={{ delay: 3000 }}
                    loop={true}
                >
                    {images.map((image, index) => (
                        <SwiperSlide key={index}>
                            <div className="logo-slider-item">
                                <Image
                                    className="logo-slider-image"
                                    src={image.src}
                                    alt={image.alt || ''}
                                    title={image.title}
                                    width={image.width || 200}
                                    height={image.height || 100}
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
        </>
    );
};

export default LogoSlider;
